'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M503.7 20.9l-2.1-10.5-10.5-2.1C446.9-.5 380-5.9 315.7 27.3 278.2 46.6 242.8 78.4 213.5 128L96 128C35.2 229.3 3.2 282.7 0 288l169.4 0 54.6 54.6 0 169.4c5.3-3.2 58.7-35.2 160-96l0-117.5c49.6-29.3 81.4-64.7 100.7-102.1 33.2-64.3 27.8-131.2 19-175.5zM256 348.6c36.8-9.2 68.6-20.5 96-33.3l0 82.6-96 57.6 0-106.9zM196.7 160c-12.9 27.4-24.1 59.2-33.3 96l-106.9 0 57.6-96 82.6 0zM330.4 55.7c50.4-26 103.6-24.7 143.9-18 6.8 40.3 8 93.5-18 143.9-27.4 53.1-86.9 106.3-211.3 136.7L193.6 267C224.1 142.6 277.3 83.1 330.4 55.7zM368 168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-56-24a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM129.8 450.9c-14.5 14.5-42.8 23.1-74.1 26.8-8.3 1-16.2 1.6-23.3 1.9 .3-7.1 .9-15 1.9-23.3 3.7-31.3 12.4-59.6 26.8-74.1 19-19 49.7-19 68.7 0s19 49.7 0 68.7zM32.4 509.4l0 0zm120-35.8c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-45.3 45.3-38 152-38 152s106.7 7.3 152-38z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;